<div class="container px-3 mt-3">
  <mat-accordion>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title class="text-white">Détails validation de la demande</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="validation-details mt-3">
        <app-current-validation-table [valideurNom]="demandeDetails?.destinataireActuel?.nom"
          [valideurPrenom]="demandeDetails?.destinataireActuel?.prenom" [statusClass]="getSafeStatusClass()"
          [statusText]="getSafeStatusText()" [statut]="demandeDetails?.statut" [motifRefusControl]="motifRefusControl"
          [viewMode]="viewMode" [validationStepsLength]="validationSteps.length"
        [advice]="advice()"></app-current-validation-table>

        <app-validation-history-table [validationSteps]="validationSteps"></app-validation-history-table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<form [formGroup]="recrutementForm">
  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Informations générales</mat-panel-title>
        </mat-expansion-panel-header>
        <fieldset>
          <app-informations-form formControlName="informationsData" [readOnly]="readOnly"
            [demandeService]="demandeDetails?.serviceFonctionnel"
          (posteSelected)="onPosteSelected($event)"></app-informations-form>
        </fieldset>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="text-white">Caractéristiques du poste</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <app-caracteristiques-form formControlName="caracteristiquesData" [readOnly]="readOnly"
          [posteId]="selectedPosteId" [typeRecrutement]="currentTypeRecrutement"></app-caracteristiques-form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="text-white">Motivation de la demande</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <fieldset>
            <div class="row">
              <div class="col-12 mb-3">
                <label class="label">Motivation de la demande *</label>
                <div class="form-text mb-1">Décrivez les raisons de la demande.</div>
                <mat-form-field class="w-100">
                  <textarea matInput [placeholder]="nbreCaratereTexte" rows="4" formControlName="motivationDemande"
                  placeholder="Saisissez la motivation de la demande" [readonly]="readOnly"></textarea>
                  @if (recrutementForm.get('motivationDemande')?.hasError('required') || recrutementForm.get('motivationDemande')?.hasError('whitespace') && recrutementForm.get('motivationDemande')?.touched) {
                    <mat-error
                      >
                      Ce champ ne peut pas être vide ou contenir uniquement des espaces.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </fieldset>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="text-white">Destinataires de la demande</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <app-destinataires-form
            formControlName="destinatairesData"
            [readOnly]="readOnly"
            demandeType="Recrutement"
            [direction]="selectedDirection()"
            [service]="selectedService()"
          ></app-destinataires-form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</form>

<div class="container px-3 mt-3">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="text-white">Pièces jointes</mat-panel-title>
      </mat-expansion-panel-header>
      @if (!PJreadOnly()) {
        <div class="mt-3">
          <div class="download-container" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="handleDragDrop($event)">
            <label style="color: dimgray">Glissez-déposez les fichiers ici *</label>
            <mat-icon color="primary">upload</mat-icon>
            <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" multiple hidden />
            <button mat-flat-button color="primary" (click)="triggerFileInput(fileInput)">
              Ou cliquez ici pour sélectionner les fichiers
            </button>
            @if (recrutementForm.get('files')?.hasError('required')) {
              <mat-error> Vous devez ajouter des pièces jointes.
              </mat-error>
            }
            @if (invalidFile) {
              <mat-error> Seuls les fichiers PDF sont autorisés. </mat-error>
            }
          </div>
        </div>
      }
      <div class="mt-3">
        @if (showAttachments) {
          <app-files-attachment [files]="attachments" [readOnly]="PJreadOnly() || PJTotal == 1"
          (close)="closeAttachments()" (fileRemoveEmit)="removePJ($event)"></app-files-attachment>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
